<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.bank.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create bank -->
        <b-modal size="xl" id="create" hide-footer>
          <template v-slot:modal-title>Novo Banco</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <label> Código </label>
                    <input type="text" v-model="code" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="ISPB" />
                    <input
                      type="text"
                      v-model="code_ispb"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create bank -->
        <v-card>
          <v-card-title>
            Bancos
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="banks"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar banco -->
              <b-modal size="xl" :id="String(item.id)" hide-footer>
                <template v-slot:modal-title>Editar Banco</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay :show="loadingBankUpdate" opacity="0.99">
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.bank.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-6">
                            <label> Código </label>
                            <input
                              :disabled="!permissions.bank.edit"
                              type="text"
                              v-model="code"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-6">
                            <LabelRequiredField label="ISPB" />
                            <input
                              :disabled="!permissions.bank.edit"
                              type="text"
                              v-model="code_ispb"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.bank.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              v-if="permissions.bank.remove"
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) => deleteBank(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar o banco? <hr /> Só pode apagar caso não exista vinculo do banco com fornecedor!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar banco -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import { formatDate } from "../functions/format";
import toast from "../components/ToastNotification";
import api from "../services/api";
import { adminData } from "../lib/functions";

export default {
  name: "Bank",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "ID", sortable: false, value: "id" },
        { text: "Código", value: "code" },
        { text: "ISPB", value: "code_ispb" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      code: "",
      code_ispb: "",
      name: "",
      banks: [],
      loadingUpdate: false,
      loadingBankUpdate: false,
      loadingCreate: false,
      loading: true,
    };
  },
  created() {
    this.retieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalBank(item.id);
      this.$bvModal.show(String(item.id));
    },
    retieve() {
      this.permissions = adminData().permissions;

      this.getBanks();
    },
    async getBanks(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/banks/paginate", {
          params: { page },
        });

        const { banks } = response.data;

        this.banks = banks;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      event.preventDefault();
      this.loadingCreate = true;

      try {
        const { code, code_ispb, name } = this;

        let params = {
          code,
          code_ispb,
          name,
        };

        const response = await api.post("/bank", params);

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.code = "";
          this.code_ispb = "";
          this.name = "";
          this.getBanks();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.code = "";
      this.code_ispb = "";
      this.name = "";
      this.$bvModal.show("create");
    },
    async handleModalBank(id) {
      try {
        this.loadingBankUpdate = true;

        this.id = id;

        const response = await api.get("/bank", {
          params: { id },
        });

        const { bank } = response.data;

        this.id = bank.id;
        this.code = bank.code;
        this.code_ispb = bank.code_ispb;
        this.name = bank.name;
        this.loadingBankUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, code, code_ispb, name } = this;

        let params = {
          id,
          code,
          code_ispb,
          name,
        };

        const response = await api.patch("/bank", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getBanks();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteBank(dialog, bank) {
      try {
        const { id } = bank;

        let data = { id };

        const response = await api.delete("/bank", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getBanks();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>